import { Progress, DefaultTooltip } from 'twyne-new.ui'

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ProgressBarFormatter({ info }) {
  const { value } = getInfo(info)

  if (!value) {
    return ''
  }

  const { success, total } = value
  const result = Math.round(success / total * 100)
  const percent = isNaN(result) ? 0 : result

  return <>
    <span className='text-dark'>
      {`${success} Delivered`} <span className='text-secondary'>{` / ${total} Assigned`}</span>
    </span>
    <div>
      <DefaultTooltip size='bottom' content={success === 0 ? 'No integrations sent.' : `${percent}%`}>
        <div className='w-36'>
          <Progress
            color="accent"
            value={percent}
          />
        </div>
      </DefaultTooltip>
    </div>
  </>
}
